var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.zipcodeCache && !_vm.generating)?_c('div',[_c('span',{staticClass:"cache-text"},[_vm._v("Der Cache für dynamische PLZ fehlt")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.generateZipcodeCache}},[_vm._v("\n    Jetzt generieren\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }